


























































































import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import axios from 'axios';

    Component({
        components: {
            HelloWorld,
        },
    })
        export default Vue.extend({
            data() {
                return {
                    choice: 0,
                    email: '',
                    updated:false,
                }
            },
            methods: {
                async updateSubscription() {
                    var self = this;
                    await axios.post('/api/Weather/email/subscription?email=' + this.email + '&sub=' + (this.choice == 0?'true':'false'))
                        .then((resp) => {
                            this.updated = true;
                            
                        })
                        .catch((error) => console.log(error));
                    
                }
            },
            async mounted() {
                if (this.$route.query.email==undefined) {
                    this.$router.push("/");
                }
                this.email = this.$route.query.email as string;


            }
        })
